/**
 * Legacy <Layout> — now a pass-through placeholder.
 *
 * The real shell (Sidebar + Header + Footer + page-content Outlet) is
 * rendered once by <AppShell> from App.js. Every page in the app still
 * imports and uses <Layout> with the same props; those props are ignored.
 *
 * This file exists only so no page file needs to change.
 */
export default function Layout({ children }) {
  return children || null;
}